import gql from 'graphql-tag'

export const MARK_TRADEMART_PARTNERSHIP_MODAL_SEEN = gql`
    mutation markTrademartPartnershipModalSeenMutation {
        markTrademartPartnershipModalSeen {
            result
            userErrors {
                field
                message
            }
        }
    }
`
